var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSomthingwrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_27)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 36,
    stroke: "#D60328",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4694 20.2583C34.216 16.8804 36.8884 14 40.2759 14V14C43.6633 14 46.3357 16.8804 46.0824 20.2583L44.1303 46.2859C43.979 48.3028 42.2984 49.8621 40.2759 49.8621V49.8621C38.2533 49.8621 36.5727 48.3028 36.4214 46.2859L34.4694 20.2583Z",
    fill: "#D60328"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.2759,
    cy: 59.7241,
    r: 6.27586,
    fill: "#D60328"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomthingwrong);
export default __webpack_public_path__ + "static/media/somthingwrong.418a250f098ec8b95852cd19bde33e9c.svg";
export { ForwardRef as ReactComponent };